// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-button {
  border-bottom: none !important;
}
.notifications-button.link {
  padding: 0 !important;
}
.notifications-button.link:hover {
  background-color: #FFF !important;
}
.notifications-button .unread-counter {
  font-size: 12px !important;
  margin-top: -36px;
  margin-left: 6px;
  background-color: #01FF94;
  color: #002E33;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  text-align: center;
  z-index: 50;
  line-height: 16px;
  position: relative;
}
.notifications-button .button {
  width: 22px;
  height: 40px;
  padding-left: 10px;
  padding-top: 4px;
}
.notifications-button .notifications-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.notifications-button .hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/client/components/notifications/Notifications.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGA;EAEI,8BAAA;AAHJ;AAKI;EACE,qBAAA;AAHN;AAIM;EACE,iCAAA;AAFR;AAMI;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBCjBU;EDkBV,cCjBS;EDkBT,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAJN;AAOI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AALN;AAQI;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AANN;AASI;EACE,aAAA;AAPN","sourcesContent":["@import \"../../Global/Layout.scss\";\n@import '../../Global/Colors';\n\n.notifications-button {\n    // position: initial;\n    border-bottom: none !important;\n\n    &.link {\n      padding: 0 !important;\n      &:hover {\n        background-color: $White !important;\n      }\n    }\n\n    .unread-counter {\n      font-size: 12px !important;\n      margin-top: -36px;\n      margin-left: 6px;\n      background-color: $ElectricGreen;\n      color: $DeepSeaGreen;\n      height: 16px;\n      width: 16px;\n      border-radius: 50%;\n      text-align: center;\n      z-index: 50;\n      line-height: 16px;\n      position: relative;\n    }\n\n    .button {\n      width: 22px;\n      height: 40px;\n      padding-left: 10px;\n      padding-top: 4px;\n    }\n\n    .notifications-overlay {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n    }\n\n    .hidden {\n      display: none;\n    }\n}\n\n\n\n\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
